/**
 * corner Radius
 */
export var lineCapRadius = 0.9;
/**
 * complete Angle
 */
export var completeAngle = 359.99;
/**
 * valueChanged event
 */
export var valueChanged = 'valueChanged';
/**
 * progressCompleted event
 */
export var progressCompleted = 'progressCompleted';
/**
 * mouseClick event
 */
export var mouseClick = 'mouseClick';
/**
 * mouseDown event
 */
export var mouseDown = 'mouseDown';
/**
 * mouseUp event
 */
export var mouseUp = 'mouseUp';
/**
 * mouseMove event
 */
export var mouseMove = 'mouseMove';
/**
 * mouseLeave event
 */
export var mouseLeave = 'mouseLeave';
